import { render, staticRenderFns } from "./Roles&Permissions.vue?vue&type=template&id=29cf24ed&scoped=true&"
import script from "./Roles&Permissions.vue?vue&type=script&lang=js&"
export * from "./Roles&Permissions.vue?vue&type=script&lang=js&"
import style0 from "./Roles&Permissions.vue?vue&type=style&index=0&id=29cf24ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cf24ed",
  null
  
)

export default component.exports